
import React, { useState } from "react";
import MainLayouts from "../../../Layout/MainLayouts";
// import { ReactComponent as ArrowLeftSquare } from "bootstrap-icons/icons/arrow-left-square-fill.svg";
import axios from "axios";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import { ReactComponent as ArrowLeftSquare } from "bootstrap-icons/icons/arrow-left-square-fill.svg";
import { ReactComponent as DashSquareFill } from "bootstrap-icons/icons/dash-square-fill.svg";
import { ReactComponent as FilePlusFill } from "bootstrap-icons/icons/file-plus-fill.svg";
import { ReactComponent as List } from "bootstrap-icons/icons/list.svg";
import ApiServices from "../../../api/ApiServices";
import { toast } from "react-toastify";
import { Link, useNavigate, } from "react-router-dom";
import { handleError } from "../../../components/utils/AuthenticationCheck";
import AxiosApiCall from "../../../api/AxiosApiCall";
import stateandcity from "../../../components/utils/stateandcity.json"
import { ReactComponent as EyeFill } from "bootstrap-icons/icons/eye-fill.svg";
import { ReactComponent as EyeSlashFill } from "bootstrap-icons/icons/eye-slash-fill.svg";


const AddBranch = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone_number, setPhoneNumber] = useState("");
  const [state, setState] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [nin, setNin] = useState("");
  const [salesRepresentatives, setSalesRepresentatives] = useState([""]);
  // const [password, setPassword] = useState("");
  // const [showPassword, setShowPassword] = useState(false);
  // const [sales_representatives, setSalesRepresentatives] = useState([""]);

  const [loading, setLoading] = useState(false);
  const selectedState = stateandcity.find((item) => item.name === state);
  const cities = selectedState ? selectedState.cities : [];


  const navigate = useNavigate();

  // Validation function
  const validateForm = () => {
    // if (!name || !email || !phone_number || !state || !city || !address || !nin || !password) {
    if (!name || !email || !phone_number || !state || !city || !address || !nin) {
      toast.error("All fields are required.");
      return false;
    }

    // if (password.length < 8) {
    //   toast.error("Password must be at least 8 characters long.");
    //   return false;
    // }

    return true;
  };



  //axios api encryption call
  const axios = AxiosApiCall();

  // handle submit button
  const handleSubmit = async (e) => {
    // console.log("form submitted");
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setLoading(true);
    const formData = {
      email,
      name,
      phone_number,
      state,
      city,
      address,
      nin,
      // password
      sales_representatives: [salesRepresentatives],
    };
    // console.log("this is my form data", formData);

    try {
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;
      if (!token) {
        throw new Error("No access token found.");
      }

      const response = await axios.post(
        ApiServices.createBranchOpe,
        formData,

        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );

      const { status, message } = response.data;
      if (status === 200 || status === 201) {
        navigate("/operations/branch/list");
        toast.success(message, { toastId: "opeartion-branch-created-success" });
        // toast.success(message);
      } else {
        handleError({ response: { status, data: { message } } }, navigate);
      }
    } catch (error) {
      handleError(error, navigate);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <MainLayouts>
        <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
          {/* form here */}
          <section className=" body-font">
            <div className="container px-5 pb-2 mx-auto ">
              <section
                className="w-full pr-[3%] pt-3 my-3"
                style={{ backgroundColor: "#F7F7F7" }}
              >
                {/* Flex container for breadcrumb and back button */}
                <div className="flex justify-between items-center bg-gray-200 py-2 px-4 rounded-lg mb-3">
                  {/* Breadcrumb - Left aligned */}
                  <nav>
                    <ol className="list-none p-0 inline-flex">
                      <li className="flex items-center">
                        <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                          Branch Operation
                        </p>
                        <ChevronRightIcon />
                      </li>
                      <li className="flex items-center">
                        <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                          Branch
                        </p>
                        <ChevronRightIcon />
                      </li>
                      <li className="flex items-center">
                        <p className="text-orange1">Create</p>
                      </li>
                    </ol>
                  </nav>

                  {/* <Link
                                        to="/operations/branch/list"
                                        className="text-dGrey3 bg-darkGreen3 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                                    >
                                        <span className="flex items-center">
                                            <ArrowLeftSquare className="mr-2" />
                                            Back To List
                                        </span>
                                    </Link> */}
                </div>
              </section>

              <div className="lg:w-full md:w-full bg-white rounded-lg p-8 flex flex-col md:ml-auto w-full mt-10 md:mt-0 relative z-10 shadow-md bg-dGrey3">
                <form onSubmit={handleSubmit}>
                  {/* Name and Email */}
                  <div className="flex flex-col md:flex-row w-full mb-3 gap-4">
                    <div className="w-full md:w-1/2">
                      <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        Branch Name
                      </label>
                      <input
                        type="text"
                        name="name"
                        id="name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                        placeholder="Enter branch name"
                      />
                    </div>
                    <div className="w-full md:w-1/2">
                      <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        Email
                      </label>
                      <input
                        type="email"
                        name="email"
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                        placeholder="Enter email address"
                      />
                    </div>

                  </div>

                  {/* Phone Number and State */}
                  <div className="flex flex-col md:flex-row w-full mb-3 gap-4">
                    <div className="w-full md:w-1/3">
                      <label htmlFor="phone" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        Phone Number
                      </label>
                      <input
                        type="tel"
                        name="phone"
                        id="phone"
                        value={phone_number}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                        className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                        placeholder="Enter phone number"
                      />
                    </div>

                    <div className="w-full md:w-1/3">
                      <label htmlFor="state" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        State
                      </label>
                      <select
                        name="state"
                        id="state"
                        value={state}
                        onChange={(e) => {
                          setState(e.target.value);
                          setCity("");
                        }}
                        className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                      >
                        <option value="">Select state</option>
                        {stateandcity.map((item) => (
                          <option key={item.name} value={item.name}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="w-full md:w-1/3">
                      <label htmlFor="city" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        City
                      </label>
                      <select
                        name="city"
                        id="city"
                        value={city}
                        onChange={(e) => setCity(e.target.value)}
                        className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                        disabled={!state}
                      >
                        <option value="">Select city</option>
                        {cities.map((cityName) => (
                          <option key={cityName} value={cityName}>
                            {cityName}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>


                  <div className="flex flex-col md:flex-row w-full mb-3 gap-4">
                    <div className="w-full md:w-1/2">
                      <label htmlFor="branchRep" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        Branch Rep
                      </label>
                      <input
                        type="text"
                        name="sales_representatives"
                        id="sales_representatives2"
                        value={salesRepresentatives}
                        onChange={(e) => setSalesRepresentatives(e.target.value)}
                        className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                        placeholder="Enter sales rep name"
                      />
                    </div>
                    <div className="w-full md:w-1/2">
                      <label htmlFor="nin" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        NIN
                      </label>
                      <input
                        type="number"
                        name="nin"
                        id="nin"
                        value={nin}
                        onChange={(e) => setNin(e.target.value)}
                        className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                        placeholder="Enter national identification number"
                      />
                    </div>



                    {/* <div className="w-full md:w-1/3">
                      <label htmlFor="password" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        Password
                      </label>
                      <div className="relative">
                        <input
                          type={showPassword ? "text" : "password"}
                          name="password"
                          id="password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full pr-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                          placeholder="Enter password"
                        />
                        <button
                          type="button"
                          onClick={() => setShowPassword(!showPassword)}
                          className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500"
                        >
                          {showPassword ? <EyeSlashFill className="w-5 h-5" /> : <EyeFill className="w-5 h-5" />}
                        </button>
                      </div>
                    </div> */}
                  </div>


                  {/* Full width text area for longer address */}
                  <div className="w-full mb-3">
                    <label htmlFor="additionalAddress" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                      Additional Address Details
                    </label>
                    <textarea
                      name="address"
                      id="address"
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                      className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                      placeholder="Apartment, suite, unit, building, etc."
                    />
                  </div>

                  {/* Buttons */}
                  <div className="flex flex-col gap-4 md:flex-row md:gap-4 md:justify-end mt-4">

                    <Link
                      to="/operations/branch/list"
                      className="text-dGrey3 bg-black2 py-4 px-6 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm  text-center"
                    >
                      <span className="flex items-center">
                        <List className="mr-2" />
                        Back To List
                      </span>
                    </Link>
                    {/* <button
                      type="submit"
                      className={`text-dGrey3 bg-darkGreen3 py-2 px-6 focus:outline-none hover:bg-indigo-600 rounded font-medium ${loading ? "btn-loading" : "btn-primary"}`}
                      disabled={loading}
                    >
                      {loading ? "Loading..." : "Create Branch"}
                    </button> */}

                    <button
                      type="submit"
                      className={`text-dGrey3 bg-darkGreen3 py-2 px-6 focus:outline-none hover:bg-indigo-600 rounded font-medium ${loading ? "btn-loading" : "btn-primary"}`}
                      // disable the button until user enter value
                      disabled={loading}
                    >
                      {loading ? "Creating Branch..." : "Create Branch"}
                    </button>

                  </div>
                </form>

              </div>

            </div>
          </section>
        </div>
      </MainLayouts>
    </div>
  );
}

export default AddBranch;

